export const debounce = (func, delay) => {
  let timeoutId;
  return (...args) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func(...args), delay);
  };
};

export const handleClickOutside = (element, callback) => {
  jQuery(document).on("click", (e) => {
    if (!element.is(e.target) && element.has(e.target).length === 0) {
      callback();
    }
  });
};

export const scrollToElement = (element, offset = 0, behavior = "smooth") => {
  const elementPosition = element.offset().top;
  const offsetPosition = elementPosition - offset;

  jQuery("html, body").animate(
    {
      scrollTop: offsetPosition,
    },
    behavior === "smooth" ? 400 : 0
  );
};
